import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, a as assertParamExists, C as COLLECTION_FORMATS, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ProductDimensionsApi - axios parameter creator
 * @export
 */
const ProductDimensionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByProduct: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/DeleteByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProduct: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/GetByProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensions: async (pid, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/GetDimensions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: async (id, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/GetPage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [dt]
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductValues: async (dt, pid, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/GetProductValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dt !== undefined) {
                localVarQueryParameter['dt'] = dt;
            }
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionToken} [ProductDimensionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ProductDimensionToken, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductDimensionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the dimensions of one product (filter.productId), optionally filtered by a term over barcodes, ERP code, color and size; used by the admin dimension pickers (e.g. discount caps, BW-8349). (Auth roles: Catalog,PromotionPolicies)
         * @param {ProductDimensionLookupRequest} ProductDimensionLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (ProductDimensionLookupRequest, X_Lookup_Metadata, options = {}) => {
            // verify required parameter 'ProductDimensionLookupRequest' is not null or undefined
            assertParamExists('lookup', 'ProductDimensionLookupRequest', ProductDimensionLookupRequest);
            const localVarPath = `/v1/ProductDimensions/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (X_Lookup_Metadata) {
                let mapped = X_Lookup_Metadata.map(value => (value || ""));
                localVarHeaderParameter['X-Lookup-Metadata'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductDimensionLookupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionToken} [ProductDimensionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ProductDimensionToken, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductDimensionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionPageToken} [ProductDimensionPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePage: async (ProductDimensionPageToken, options = {}) => {
            const localVarPath = `/v1/ProductDimensions/UpdatePage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductDimensionPageToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductDimensionsApi - functional programming interface
 * @export
 */
const ProductDimensionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductDimensionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByProduct(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByProduct(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.deleteByProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByProduct(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByProduct(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.getByProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensions(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensions(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.getDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPage(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.getPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [dt]
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductValues(dt, pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductValues(dt, pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.getProductValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionToken} [ProductDimensionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ProductDimensionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ProductDimensionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns the dimensions of one product (filter.productId), optionally filtered by a term over barcodes, ERP code, color and size; used by the admin dimension pickers (e.g. discount caps, BW-8349). (Auth roles: Catalog,PromotionPolicies)
         * @param {ProductDimensionLookupRequest} ProductDimensionLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(ProductDimensionLookupRequest, X_Lookup_Metadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(ProductDimensionLookupRequest, X_Lookup_Metadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionToken} [ProductDimensionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ProductDimensionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ProductDimensionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionPageToken} [ProductDimensionPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePage(ProductDimensionPageToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePage(ProductDimensionPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductDimensionsApi.updatePage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ProductDimensionsApi - factory interface
 * @export
 */
const ProductDimensionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductDimensionsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByProduct(pid, options) {
            return localVarFp.deleteByProduct(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByProduct(pid, options) {
            return localVarFp.getByProduct(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensions(pid, options) {
            return localVarFp.getDimensions(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage(id, options) {
            return localVarFp.getPage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [dt]
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductValues(dt, pid, options) {
            return localVarFp.getProductValues(dt, pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionToken} [ProductDimensionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ProductDimensionToken, options) {
            return localVarFp.insert(ProductDimensionToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the dimensions of one product (filter.productId), optionally filtered by a term over barcodes, ERP code, color and size; used by the admin dimension pickers (e.g. discount caps, BW-8349). (Auth roles: Catalog,PromotionPolicies)
         * @param {ProductDimensionLookupRequest} ProductDimensionLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(ProductDimensionLookupRequest, X_Lookup_Metadata, options) {
            return localVarFp.lookup(ProductDimensionLookupRequest, X_Lookup_Metadata, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionToken} [ProductDimensionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ProductDimensionToken, options) {
            return localVarFp.update(ProductDimensionToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductDimensionPageToken} [ProductDimensionPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePage(ProductDimensionPageToken, options) {
            return localVarFp.updatePage(ProductDimensionPageToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductDimensionsApi - object-oriented interface
 * @export
 * @class ProductDimensionsApi
 * @extends {BaseAPI}
 */
class ProductDimensionsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    deleteByProduct(pid, options) {
        return ProductDimensionsApiFp(this.configuration).deleteByProduct(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    getByProduct(pid, options) {
        return ProductDimensionsApiFp(this.configuration).getByProduct(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    getDimensions(pid, options) {
        return ProductDimensionsApiFp(this.configuration).getDimensions(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    getPage(id, options) {
        return ProductDimensionsApiFp(this.configuration).getPage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [dt]
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    getProductValues(dt, pid, options) {
        return ProductDimensionsApiFp(this.configuration).getProductValues(dt, pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductDimensionToken} [ProductDimensionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    insert(ProductDimensionToken, options) {
        return ProductDimensionsApiFp(this.configuration).insert(ProductDimensionToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the dimensions of one product (filter.productId), optionally filtered by a term over barcodes, ERP code, color and size; used by the admin dimension pickers (e.g. discount caps, BW-8349). (Auth roles: Catalog,PromotionPolicies)
     * @param {ProductDimensionLookupRequest} ProductDimensionLookupRequest
     * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    lookup(ProductDimensionLookupRequest, X_Lookup_Metadata, options) {
        return ProductDimensionsApiFp(this.configuration).lookup(ProductDimensionLookupRequest, X_Lookup_Metadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    remove(id, options) {
        return ProductDimensionsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductDimensionToken} [ProductDimensionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    update(ProductDimensionToken, options) {
        return ProductDimensionsApiFp(this.configuration).update(ProductDimensionToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductDimensionPageToken} [ProductDimensionPageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductDimensionsApi
     */
    updatePage(ProductDimensionPageToken, options) {
        return ProductDimensionsApiFp(this.configuration).updatePage(ProductDimensionPageToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ProductDimensionsApi, ProductDimensionsApiAxiosParamCreator, ProductDimensionsApiFactory, ProductDimensionsApiFp };
//# sourceMappingURL=product-dimensions-api.js.map
